import { advantageService } from "../../services/api";
import { Advantage } from "../../types/advantage/advantage";

let advantageList: Advantage[] = [
  {
    id: 1,
    name: "Родина однодумців",
    description: "Основу полку складають добровольці, які долучились до лав ЗСУ за покликом серця. Ми чітко розуміємо кінцеву мету – це Перемога України. Для всіх нас Україна – понад усе!",
  },
  {
    id: 2,
    name: "Командування",
    description: "Наші командири вміло поєднують цивільний досвід менеджера та бойові навички Бійця. Людяність, гідність, повага та братерство - найвищі цінності в нашому колективі",
  },
  {
    id: 3,
    name: "Якісна підготовка",
    description: "Наш пріоритет – навченість кожного Бійця. Інструктори 210 ОШП розробили унікальну навчальну програму, яка поєднує стандарти NATO з досвідом сучасної війни. Знання рекрутам передають ветерани бойових дій. Все це є запорукою збереження життя та здоров'я особового складу",
  },
  {
    id: 4,
    name: "Ретельний добір",
    description: "Цінності нашого полку не дозволяють затриматися тут випадковим незрілим особистостям. Бійці, які схильні до зловживання забороненими речовинами, різноманітні маргинали та особи з меркантильними намірами, як правило, дуже швидко залишають наш полк",
  },
  {
    id: 5,
    name: "Сучасна зброя",
    description: "В нашому полку використовуються новітні зразки озброєння, зокрема й виробництва країн NATO. Ми проводимо постійну практичну підготовку особового складу для опанування сучасної зброї та техніки",
  },
  {
    id: 6,
    name: "Забезпечення",
    description: "Повне матеріальне та грошове забезпечення до 200 тисяч грн. Соціальні гарантії для військовослужбовців згідно з чинним законодавством",
  },
];

export async function loadAdvantages() {
  try {
    // Call the API to get all advantage entries
    const response = await advantageService.getAll();

    // Extract the data from the response
    const newAdvantageList: Advantage[] = response.data;

    // Sort by orderID before returning
    advantageList = newAdvantageList.sort((a, b) => a.id - b.id);
  } catch (error) {
    console.error("Failed to load advantages:", error);
    throw new Error("Не вдалося завантажити переваги");
  }
}


export function getAdvantages() {
  return advantageList;
}
